import { ReactElement } from 'react';
import { UserModalTypes } from '@/pages/Users/components/UserModal/types';

const UserTitle = ({ firstName, lastName }: UserModalTypes.TitleProps): ReactElement => {
  const title = [firstName, lastName].filter(Boolean).join(' ')?.trim() || 'Create New User';

  return (
    <h3>
      <span>
        <i className="fa fa-location-dot" />
      </span>
      <span>{title}</span>
    </h3>
  );
};

export default UserTitle;
